import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import type { PublicWidgetResponse } from '../widget-api/public-widget';
import { useQuerySuffix } from '../widget-hooks/useQuerySuffix';
import { displayableMediaUrl } from '../widget-lib/media-url';
import { PATH } from '../widget-lib/path-routes';
import { MediaAvatar } from '../widget-ui/media-avatar';

type Props = {
  config: PublicWidgetResponse;
};

/**
 * Баннер шапки виджета: размытое фото фона, иконка-лого + название.
 */
export function EmbedOrgHeroHeader({ config }: Props) {
  const [heroFailed, setHeroFailed] = useState(false);
  const suffix = useQuerySuffix();
  const heroSrc = displayableMediaUrl(config.photo_url);
  const showHeroBg = heroSrc != null && !heroFailed;

  useEffect(() => {
    setHeroFailed(false);
  }, [heroSrc]);

  const name = (config.name || '').trim() || 'Организация';
  const homeTo = `${PATH.home}${suffix}`;
  return (
    <div
      className={`relative h-14 overflow-hidden sm:h-16 ${showHeroBg ? '' : 'bg-[var(--accent-bg)]'}`}
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      {showHeroBg ? (
        <img
          src={heroSrc}
          alt=""
          className="absolute inset-0 h-full w-full scale-110 object-cover blur-sm"
          sizes="100vw"
          decoding="async"
          onError={() => setHeroFailed(true)}
        />
      ) : null}
      <div
        className={`pointer-events-none absolute inset-0 ${showHeroBg ? 'bg-[var(--bg-elevated)]/55' : ''}`}
        aria-hidden
      />

      <NavLink
        to={homeTo}
        className="relative z-[1] flex h-full items-center gap-3 px-3 sm:px-5 transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--accent-fg)]"
        aria-label={`${name} — главная страница виджета`}
      >
        <MediaAvatar
          photoUrl={config.brand_logo_url}
          label={name}
          sizeClass="h-9 w-9 shrink-0 sm:h-10 sm:w-10"
          roundedClass="rounded-xl ring-2 ring-white/20 shadow-lg"
          imgSizes="(max-width: 640px) 36px, 40px"
        />
        <h1
          className={`min-w-0 flex-1 truncate text-sm font-semibold tracking-tight sm:text-base ${
            showHeroBg ? 'text-[var(--text)]' : 'text-[var(--accent-fg)]'
          }`}
        >
          {name}
        </h1>
      </NavLink>
    </div>
  );
}
